import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'do_workers_understand_terms_conditions_within_their_written'

export const dataPointDefinition = {
  retracedId: 'do_workers_understand_terms_conditions_within_their_written',
  name: 'Do workers understand the terms and conditions within their written employment contracts, including the terms related to',
  description: 'Answer Yes if workers are familiar with and understand the terms and conditions of employment.',
  meta: {
    slcpMeta: {
      key: 'ep-3--4',
      number: 'RH-EMP-13',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ep-3--4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26950,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
